function convertSelectricToRadio(){

    $('td.label').hide()
    $('td.value').hide()

    $('select#pa_media-type option').each(function(){

        let value = $(this).attr( "value");
        let text = $(this).text()

        //If there is no value don't display option
        if(!value) return;

        $('.variations').append(`<label class="${value}" for="${value}">${text}</label>`);

        let newRadio = $('<input>');
        newRadio.attr({
            type: 'radio',
            id: value,
            name: 'media type',
            value: value,
            checked: $(this).is(':selected')
        }).appendTo('.variations label.' + value);

        $('.variations label.' + value).append(`<span class="checkmark"></span>`);


        $(newRadio).on('click', function() {
            $('select').val(value);
            $('select').trigger('change');
            // $('select option').trigger( 'woocommerce_variation_select_change' );
            // $('select option').trigger( 'show_variation' )
        });


    })
}



